module.exports = __webpack_public_path__ + "img/logo_hipercob.a7bab77d.png";